module.exports = __webpack_public_path__ + "static/img/p_02.6f4260c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/p_02.png
// module id = 756
// module chunks = 1